import React, {useContext} from "react"
import {AssociateFilterContext} from "./context/AssociateFilterContext";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import ControlGroup from "@amzn/meridian/control-group";
import Checkbox from "@amzn/meridian/checkbox";
import Column from "@amzn/meridian/column";
import {FormattedMessage, injectIntl} from "react-intl";
import Link from "@amzn/meridian/link";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import FilterExpander from "../common/FilterExpander";
import {MobileDisplay} from "../common/MobileDisplay";
import FilterTags from "./FilterTags";

const AssociateFilter = ({ intl }) => {
    const {states, dispatch} = useContext(AssociateFilterContext)
    const {isMobile, spacingInset_shorthand3} = useDeviceLayout();

    const isFilterSet = () => {
        return states.length !== 0;
    }

    const clearAllFilters = () => {
        dispatch({type: 'REMOVE_ALL_STATES'});
    }

    const renderActiveAssociateControlGroup = () => {
        return (
            <ControlGroup
                label={intl.formatMessage({id: 'associate.active', defaultMessage: "Active"})}
                name="state"
                onChange={(data) => dispatch({ type: 'SELECT_STATE', state: data })}
                value={states}>
                <Checkbox key="yes" value="Yes"><FormattedMessage id="associate.yes" defaultMessage="Yes"/></Checkbox>
                <Checkbox key="no" value="No"><FormattedMessage id="associate.no" defaultMessage="No"/></Checkbox>
            </ControlGroup>
        );
    }

    const renderFilterSection = () => {
        return (
            <React.Fragment>
                {renderActiveAssociateControlGroup()}
                {isFilterSet() && (
                    <Row width="100%" spacingInset="small none none none">
                        <FilterTags states={states} onRemove={(state) => dispatch({ type: 'REMOVE_STATE', state})} />
                        <Link onClick={clearAllFilters} type="secondary">
                            <FormattedMessage id="linehaul_filter.clear_all" defaultMessage="Clear all"/>
                        </Link>
                    </Row>
                )}
            </React.Fragment>
        );
    }

    return (
        <Column>
            <Box>
                {isMobile ?
                    <FilterExpander>
                        <Column alignmentHorizontal={"stretch"} alignmentVertical={"center"} spacingInset={"small medium"} backgroundColor="secondary">
                            {renderFilterSection()}
                        </Column>
                    </FilterExpander> :
                    <Row width="100%" spacingInset={spacingInset_shorthand3} backgroundColor="secondary">
                        {renderActiveAssociateControlGroup()}
                    </Row>
                }
            </Box>
            <MobileDisplay visibility={false}>
                <Row width="100%">
                    <FilterTags states={states} onRemove={(state) => dispatch({ type: 'REMOVE_STATE', state})} />
                    {isFilterSet() ? <Link onClick={clearAllFilters} type="secondary">
                        <FormattedMessage id="linehaul_filter.clear_all" defaultMessage="Clear all"/>
                    </Link> : null}
                </Row>
            </MobileDisplay>
        </Column>
    )
}

export default injectIntl(AssociateFilter)


// WEBPACK FOOTER //
// ./src/components/associate/AssociateFilter.js